import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { NotifyParticipantDocumentReviewers } from '../mutations/notifyParticipantDocumentReviewers.mutation';
import type {
  NotifyParticipantDocumentReviewersMutation,
  NotifyParticipantDocumentReviewersMutationVariables,
} from '../types';

export const useNotifyParticipantDocumentReviewersMutation = (
  options?: MutationOptions<
    NotifyParticipantDocumentReviewersMutation,
    NotifyParticipantDocumentReviewersMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(NotifyParticipantDocumentReviewers), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
